import { useContext } from 'react';
import { useSelector } from 'react-redux';

import { EnrollmentContext } from '@modules/members/enrollments/context/MemberMyEnrollmentProvider';

const useValidateAPTCAmount = () => {
    const permissions = useSelector((state: any) => state.memberEnrollment?.permissions);
    const { isMinimumPremiumGlobalPropertyValueAvailable, minimumPremiumGlobalPropertyValue } = permissions || {};
    const { enableContinueButton, enrollmentPremiumFormContext, selectedEnrollment } = useContext(EnrollmentContext);
    const { setValue } = enrollmentPremiumFormContext;

    const isValidAptc = premium => {
        const aptcAmount = parseFloat(premium.aptcAmount);
        const grossPremiumAmount = parseFloat(premium.grossPremiumAmount);
        const ehbPercent = parseFloat(selectedEnrollment.ehbPercent || 0);
        const maxAptc = parseFloat(premium.maxAptc || 0);

        if (ehbPercent) {
            if (grossPremiumAmount * ehbPercent < aptcAmount) {
                return false;
            }
        } else {
            if (grossPremiumAmount < aptcAmount) {
                return false;
            }
        }

        if (premium.maxAptc !== undefined && aptcAmount > maxAptc) {
            return false;
        }

        return true;
    };

    return premiumData => {
        const premium = { ...premiumData };
        enableContinueButton();
        if (isValidAptc(premium)) {
            premium.netPremiumAmount = parseFloat(premium.grossPremiumAmount);

            if (premium.aptcAmount !== undefined) {
                const netPremiumAfterAptc = premium.netPremiumAmount - premium.aptcAmount;
                if (netPremiumAfterAptc < premium.minimumPremium) {
                    premium.aptcAmount = premium.grossPremiumAmount - premium.minimumPremium;
                    premium.netPremiumAmount = premium.minimumPremium;
                } else {
                    premium.netPremiumAmount = netPremiumAfterAptc;
                }
            }
        } else {
            premium.netPremiumAmount =
                premium.grossPremiumAmount - ((premium.stateSubsidyAmount || 0) + (premium.aptcAmount || 0));
        }

        if (premium.stateSubsidyAmount !== undefined) {
            premium.netPremiumAmount =
                parseFloat(premium.netPremiumAmount) - parseFloat(premium.stateSubsidyAmount || 0);
        }
        if (premium.statePremiumCreditAmt !== undefined) {
            if (premium.netPremiumAmount - premium.statePremiumCreditAmt < 0) {
                premium.netPremiumAmount = 0;
            } else {
                premium.netPremiumAmount = premium.netPremiumAmount - premium.statePremiumCreditAmt;
            }
        }

        if (premium?.isMedicaidTransitionEligible) {
            const medicaidTransitionAmount =
                premium.grossPremiumAmount -
                (premium.aptcAmount + (premium.stateSubsidy2Amount || 0) + premium.stateSubsidyAmount) -
                (premium.maxAptc - premium.aptcAmount);
            premium.medicaidTransitionAmount = medicaidTransitionAmount < 0 ? 0 : medicaidTransitionAmount;
            setValue(
                `enrollmentPremiumDtoList.${premium.month - 1}.medicaidTransitionAmount`,
                premium.medicaidTransitionAmount,
                {
                    shouldDirty: true,
                    shouldValidate: true,
                },
            );
        }
        premium.netPremiumAmount = Number(parseFloat(premium?.netPremiumAmount).toFixed(2) || 0);

        setValue(`enrollmentPremiumDtoList.${premium.month - 1}.netPremiumAmount`, premium.netPremiumAmount, {
            shouldDirty: true,
            shouldValidate: true,
        });
    };
};

export default useValidateAPTCAmount;
